import { render, staticRenderFns } from "./TwoLayerPopup.vue?vue&type=template&id=67894374&scoped=true&"
import script from "./TwoLayerPopup.vue?vue&type=script&lang=js&"
export * from "./TwoLayerPopup.vue?vue&type=script&lang=js&"
import style0 from "./TwoLayerPopup.vue?vue&type=style&index=0&id=67894374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67894374",
  null
  
)

export default component.exports